import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'

// This schema is a shared source of truth for github-ui (front-end rendering) and
// the github/marketing-hub Next.js app (server-side page config). Some fields below have
// no github-ui consumers today but are read by github/marketing-hub's back-end, so do not
// remove "unused" fields without checking github/marketing-hub first.
export const PageSettingsSchema = buildEntrySchemaFor('pageSettings', {
  fields: z.lazy(() =>
    z.object({
      hasMinimalFooter: z.boolean().optional(),
      isHidden: z.boolean().optional(),
      revenuePlay: z.enum(['AI', 'Platform', 'Security']).optional(),
      featureFlag: z.string().optional(),
      colorMode: z.enum(['light', 'dark']).default('light'),
      globalNavbarStyle: z.enum(['default', 'black', 'dark transparent', 'white', 'light transparent']).optional(),
    }),
  ),
})

export type PageSettings = z.infer<typeof PageSettingsSchema>
